// extracted by mini-css-extract-plugin
module.exports = {"img":"colunms_img__3ERai","videoResponsive":"colunms_videoResponsive__3Hpig"};